import React from 'react'

function Brand(props) {
  const { inverse } = props
  let logo = props.logo
  if ((props.logo_white || {}).src && inverse) {
    logo = props.logo_white
  }
  return (
    <a href="/" className={props.className || "navbar-brand"}>
      {
        logo.src &&
        <img src={logo.src} />
      }
      {
        !logo.src &&
        <span>{props.site_name.content}</span>
      }
    </a>
  )
}

export default Brand


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/header/brand/index.js